/** Reserve the checkout tab while the browser still has the click gesture. */
export function reserveCheckoutWindow(browser = window) {
  const tab = browser.open('about:blank', '_blank');
  if (tab) {
    try { tab.opener = null; } catch { /* The browser may restrict opener access. */ }
  }
  return tab;
}

export function navigateCheckoutWindow(tab, url) {
  if (!tab || tab.closed) return false;
  tab.location.replace(url);
  return true;
}

export function closeCheckoutWindow(tab) {
  if (tab && !tab.closed) tab.close();
}
